import { render, staticRenderFns } from "./TblFlowDetail.vue?vue&type=template&id=21ac354c&scoped=true&"
import script from "./TblFlowDetail.vue?vue&type=script&lang=js&"
export * from "./TblFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblFlowDetail.vue?vue&type=style&index=0&id=21ac354c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac354c",
  null
  
)

export default component.exports